<!-- PremiumModal.vue -->
<script setup>
import BaseModal from './BaseModal.vue';

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['close']);

const close = () => {
  emit('close');
};
</script>

<template>
  <BaseModal :show="show" @close="close">
    <!-- Icon Slot -->
    <template #icon>
      <i class="bi bi-gem" style="color: #ffc107;"></i>
    </template>

    <!-- Message Slot -->
    <template #message>
      <h2>Upgrade to Premium</h2>
      <p>Unlock all filters and enjoy the best betting experience for just £6.67 per month! Upgrade
        your account today to access exclusive features and premium content!</p>
    </template>

    <!-- Actions Slot -->
    <template #actions>
      <a href="/payments/checkout/" class="button button-continue">Upgrade Now</a>
      <button @click="close" class="button button-close" datatype="inverted">Maybe Later</button>
    </template>
  </BaseModal>
</template>

<style scoped>
/* Additional Styles for PremiumModal */
.modal-icon i {
  font-size: 5rem;
}
</style>
